import type { BaseError } from '@/modules/errors/constants/error-class-map.gen';

export const commonWretchErrorHandlerSugarMethods = [
  'badRequest',
  'unauthorized',
  'forbidden',
  'notFound',
  'timeout',
  'internalError',
  'fetchError',
] as const;

export type CommonWretchErrorHandlerMapKey =
  | (typeof commonWretchErrorHandlerSugarMethods)[number]
  | number; // arbitary HTTP status code

export type CommonWretchErrorHandlerMap = Map<
  CommonWretchErrorHandlerMapKey,
  new (originalError?: Error) => BaseError
>;
